import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-118">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-119">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-120" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl max-h-[80vh] flex flex-col" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-121">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-122">
              <h2 id="modal-title" className="text-2xl font-bold text-gray-900" data-id="element-123">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-lg hover:bg-gray-100" aria-label="Close modal" data-id="element-124">
                <XIcon className="w-6 h-6" data-id="element-125" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto p-6 flex-1" data-id="element-126">{children}</div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}